import { Divider, DividerProps, useTheme } from '@mui/material';
import { ElementType } from 'react';

interface propTypes extends DividerProps {
  space?: number;
  component?: ElementType<any>;
}

export const DtxSpacer = (props: propTypes) => {
  const { space = 2.5, sx, ...rest } = props;
  const theme = useTheme();
  const direction =
    rest?.orientation === 'vertical' ? 'borderRightWidth' : 'borderBottomWidth';
  return (
    <Divider
      sx={{
        borderColor: 'transparent',
        ...sx,
        ...{ [direction]: theme.spacing(space) },
      }}
      {...rest}
    />
  );
};
